const testisAbnormal =[
        
        { 
        label:"Side",
        controlType:"radio button",
        options:["Right", "Left", "Bilateral"]
        },
        {
            
        label:"Involving",
        controlType:"checkbox group",
        options:["Testis", "Epididymis",]
        },
        
        { 
        label:"Consistency change:",
        controlType:"radio button",
        options:["Normal","Harder", "Softer"]
        },
    
        { 
        label:"Texture:",
        controlType:"radio button",
        options:["Smooth", "Irregular"]
        },
    
        { 
        label:"Pain:",
        controlType:"radio button",
        options:["Painful", "Painless"]
        },
    
        { 
        label:"Tenderness:",
        controlType:"radio button",
        options:["Tender", "Non-tender"]
        },
    
        { 
        label:"Present for several:",
        controlType:"radio button",
        options:["Days", "Weeks","Months","Years"]
        }
        
    ]
    
    
    export default testisAbnormal